import React from "react"
import LayoutFirebase from "../src/LayoutFirebase"
import MetaTags from "../src/MetaTags"
import PricingGrid from "../src/PricingGrid"
import FAQ from "../src/Faq"
import { useRouter } from "next/router"
import { useTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import ThreeInOne from '../src/ThreeInOne'

const Search = () => {
  const { basePath } = useRouter()
  const { t } = useTranslation()

  return (
    <>
      <MetaTags title={t("pricing.title")} description="" />
      <LayoutFirebase>
        <section className="text-gray-600 overflow-hidden">
            <PricingGrid />
          <ThreeInOne />
            <div className="mt-28">
              <FAQ
                faqs={[
                  {
                    question: "Why are the AI features not free?",
                    answer:
                      "Our AI features require significant computational resources and advanced technology to deliver high-quality results. The costs associated with running these AI models, including GPU usage and ongoing development, necessitate a subscription model to ensure we can continue providing and improving this service.",
                  },
                  {
                    question:
                      "Can I get a refund for the AI moodboard and room design generations?",
                      answer: "We understand that you may have concerns about the quality of our AI-generated designs. However, due to the immediate consumption of computational resources when generating AI moodboards and room designs, we generally cannot offer refunds once the service has been used. The costs associated with running our advanced AI models are incurred as soon as a generation is initiated. That said, we value your satisfaction and feedback. If you're unsatisfied with the results, please contact our support team. We'll review each case individually and may offer alternatives such as additional generations or guidance on how to achieve better results with our AI tool. In exceptional circumstances, we may consider partial refunds. Our primary goal is to ensure you have a positive experience with our service and find value in the AI-generated designs.",

                  },
                  {
                    question:
                      "How do I cancel my subscription?",
                    answer:
                      "You can easily manage and cancel your subscription at any time through your user dashboard. Simply log in to your account, navigate to the subscription management section, and follow the prompts to cancel. Your access to the AI room designer and mood board generation will continue until the end of your current billing period.",
                  },
                  {
                    question:
                      "How can interior designers leverage this AI room design tool?",
                    answer:
                      "Interior designers can use our AI tool to quickly generate multiple design concepts, explore different styles and layouts, and streamline their creative process. It's an excellent tool for initial ideation, client presentations, and visualizing spaces before committing to final designs. The AI can also help designers stay updated on current trends and discover new design possibilities.",
                  },
                  {
                    question: "Can I change my subscription plan?",
                    answer:
                      "Yes, you can upgrade or downgrade your subscription plan at any time. Changes will take effect immediately and you will be billed pro-rata for the remaining days of your current plan.",
                  },
                ]}
              />
            </div>
        </section>
      </LayoutFirebase>
    </>
  )
}
export default Search

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale)),
  },
})
